import {CalendarEventResource} from "../../../shared/types/calendar-types/calendarEventResource";
import {endTimeCalculation} from "./calendar-helper.mapper";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function mapCalendarEventResourceToSyncfusionEvent(event: CalendarEventResource, translate: boolean): any {
  return {
    Id: event.id,
    Subject: (translate && event.name_translated !== null) ? event.name_translated : event.name,
    Description: (translate && event.description_translated !== null) ? event.description_translated : event.description,
    Location: (translate && event.location_translated !== null) ? event.location_translated : event.location ?? '',
    Priority: event.priority,
    StartTime: event.timing.start_at,
    EndTime: endTimeCalculation(new Date(event.timing.start_at, ), event.timing.duration, event.timing.is_full_day).toISOString(),
    IsAllDay: event.timing.is_full_day,
    StartTimezone: event.timing.timezone,
    EndTimezone: event.timing.timezone,
    RecurrenceRule: event.recurrence.rrule,
    RecurrenceID: event.override.parent_id ?? null,
    RecurrenceException: mapRecurrenceExceptions([...event.recurrence.deleted_occurrences, ...event.recurrence.overridden_occurrences], event.timing.start_at),
    CalendarId: event.calendar_id,
    ParticipantsUserIDs: event.participants.user_ids,
    ParticipantsGroupIDs: event.participants.group_ids,
    ParticipantsMails: event.participants.external_user_emails,
    PushUserIDs: event.participants.notify_user_ids,
    PushGroupIDs: event.participants.notify_group_ids,
    IsReadonly: !event.permission.editable,
    // maxParticipants: !!! missing !!!,
    notifyBeforeMinutes: event.timing.notify_before,
    isEditable: true,

    //custom color field
    eventColor: event.priority === 'high' ? 'var(--our-error-red)' : event.priority === "medium" ? 'var(--our-yellow)' : 'var(--our-light-green)'
  };
}

function mapRecurrenceExceptions(exceptions: string[], start: string): string {
  if (!exceptions || exceptions.length === 0) return '';
  
  // Extract time: "2026-01-21T10:31:00.000Z" -> "103100Z"
  const timeMatch = start.match(/T(\d{2}):(\d{2}):(\d{2})/);
  if (!timeMatch) return '';
  const timePart = `${timeMatch[1]}${timeMatch[2]}${timeMatch[3]}Z`;

  return exceptions.map(ex => {
    // Force the date to be parsed as UTC to avoid the "Previous Day" shift
    // Works whether ex is "2026-01-22" or "2026-01-22T10:31:00Z"
    const d = new Date(ex.includes('T') ? ex : `${ex}T00:00:00Z`);
    
    const year = d.getUTCFullYear();
    const month = (d.getUTCMonth() + 1).toString().padStart(2, '0');
    const day = d.getUTCDate().toString().padStart(2, '0');
    
    return `${year}${month}${day}T${timePart}`;
  }).join(',');
}
